import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { BusinessObjectBase, L10nBase, ModelBase, RepositoryBase, RepositoryResponseCode } from '@skylab-shared/core';

import { L10n } from '@skylab-angular-shared/core';
import { DialogInsService, DialogState } from '@skylab-angular-shared/ui';
import { FormBase, FormBaseViewModel } from '../form/form-base';

type FormComponent = FormBase<FormBaseViewModel, RepositoryBase<BusinessObjectBase<ModelBase>, ModelBase>, BusinessObjectBase<ModelBase>, ModelBase>;

export const canDeactivateFormDirty = (): CanDeactivateFn<FormComponent> => {
	return async component => {
		const dialogService = inject(DialogInsService);
		const l10n = inject(L10n) as L10nBase;
        const result = await handleDeactivateForm(component, dialogService, l10n);
        return result.canDeactivate;
	};
};

export async function handleDeactivateForm(component: FormComponent, dialogService: DialogInsService, l10n: L10nBase): Promise<{canDeactivate: boolean; saved: boolean}> {
    if (component.isFormDirty.value) {
        return dialogService.showConfirmAsync({
            title: l10n._T('scenes.shared.guards.form-dirty-can-deactivate.exit-confirmation.title'),
            text: l10n._T('scenes.shared.guards.form-dirty-can-deactivate.exit-confirmation.message'),
            buttons: [{
                text: l10n._T('scenes.shared.guards.form-dirty-can-deactivate.exit-confirmation.buttons.yes'),
                state: DialogState.Confirm,
                type: 'accent',
                focus: true
            }, {
                text: l10n._T('scenes.shared.guards.form-dirty-can-deactivate.exit-confirmation.buttons.no'),
                state: DialogState.Decline,
            }, {
                text: l10n._T('scenes.shared.guards.form-dirty-can-deactivate.exit-confirmation.buttons.cancel'),
                state: DialogState.Cancel,
            }]
        }).then(result => {
            if (result.state === DialogState.Confirm) {
                return component.saveAsync().then(result => {
                    const state = result?.code === RepositoryResponseCode.Success ? true : false;
                    return { canDeactivate: state, saved: state };
                });
            } else if (result.state === DialogState.Decline) {
                return Promise.resolve({ canDeactivate: true, saved: false });
            } else {
                return Promise.resolve({ canDeactivate: false, saved: false });
            }
        });
    } else {
        return Promise.resolve({ canDeactivate: true, saved: false });
    }
}
